export enum DAYPLANNER_STORAGE_KEYS {
  MechanicSortingPreference = "dayplanner-mechanic-sorting-preference",
  PinnedMechanicsPreference = "dayplanner-pinned-mechanics-preference",
  SelectedMechanicPreference = "dayplanner-selected-mechanic-preference",
  SelectedWoInternalPreference = "dayplanner-selected-wo-internal-preference",
  SelectedActiveStatusFiltersPreference = "dayplanner-selected-active-status-filters-preference",
  CollapsedColumnsPreference = "dayplanner-collapsed-columns-preference",
  AppointmentBrandsPreference = "dayplanner-appointment-brands-preference"
}
